







import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class NavigatorLink extends Vue {
    @Prop()
    public readonly disabled!: boolean;

    @Prop()
    public readonly to!: string;

    @Prop()
    public readonly attrs!: Record<string, string>;

    public onClick(e: MouseEvent) {
        if (this.attrs?.['data-action']) {
            e.preventDefault();
            window.$authWidget.goToLK();
        }
    }
}
